import React from 'react';

export function ShortEnrollmentHeader({
        step, 
        title, 
        subTitle, 
        customClass = 'pr-2'}) {
    return (
        <>
            <div className="row">
                <div className="col-2 col-sm-2">
                    <p className="header-number consumer">{step}</p>
                </div>
                {/*<div className="col-sm-10 col-10 pt-4 pl-4">*/}
                <div className="col-sm-10 col-10">
                    <h3 className="euclid">{title}</h3>
                    <div className="d-sm-inline-block"><i>{subTitle}</i></div>
                    <div className={"text-right d-inline-block float-right " + customClass}>*required</div>
                </div>
                <div class="row grey-spacer-col-1"></div>
            </div>
        </>
    )
}

export default ShortEnrollmentHeader;